import {IUpdateEmail} from '../../../coreGlobal/models/user'

export const BuildRequest = async (data: IUpdateEmail) => {
  return {
    email: data.newEmail,
    current_password: data.confirmPassword,
  }
}
